






















































































































































































































































































































































import {Component, Mixins} from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Breadcrumb from '@/models/Breadcrumb';
import Filter from '@/models/search/filter/Filter';
import Selected from '@/models/search/filter/Selected';
import Group from '@/models/search/filter/Group';
import Category from '@/models/search/filter/Category';
import Alert from '@/models/Alert';
import Overlay from '@/models/Overlay';
import {fetchFilters, fetchResult} from '@/repositories/api/SearchApi';
import BasePageView from '@/views/BasePageView.vue';
import ApiResponseOld from '@/interfaces/ApiResponseOld';
import {AlertTypes} from '@/models/AlertTypes';

@Component({
  components: {
    BaseLayout,
  }
})
export default class SearchView extends BasePageView {
  protected dialog = true;
  protected overlay = new Overlay();
  protected breadcrumbs: Breadcrumb[] = [
    {
      text: 'Accueil',
      disabled: false,
      icon: '',
      href: '/',
    },
    {
      text: 'Données',
      disabled: false,
      icon: '',
      href: '/donnees',
    },
    {
      text: 'Recherche',
      disabled: true,
      icon: '',
      href: '/donnees/recherche',
    },
  ];
  protected alert = new Alert();

  protected filter: Filter = new Filter();
  protected selected: Selected = new Selected();
  protected emptySelected: Selected = new Selected();
  protected items = [];
  protected properties = [];
  protected result: {items: {}[], properties: {}[]} = {items: [], properties: []};


  get computedProperties() {
    return this.result.properties;
  }

  get computedFilteredProperties() {
    return this.computedProperties.filter(
      property =>
        //@ts-ignore
        this.selected.fields.includes(property) || property === '__group'
    );
  }

  get sessions() {
    return this.filter.sessions;
  }

  get categories() {
    return this.filter.categories;
  }

  get category() {
    const categories = this.filter.categories.filter(
      category => category.id === this.selected.category
    );

    return categories.length > 0 ? categories[0] : null;
  }

  get groups() {
    let groups: Group[] = [];
    let categories: Category[] = [];

    if (this.categories && this.categories.length > 0) {
      categories = this.categories.filter(
        category => category.id === this.selected.category
      );

      if (categories.length > 0) {
        categories.forEach(category => (groups = [...category.groups]));
      }
    }

    return groups;
  }

  get columns() {
    return this.category ? this.category.columns : [];
  }

  get columnCategories(): Category[] {
    let categories: Category[] = [];

    if (this.category && this.category.columns) {
      categories = this.category.columns
        .map(column => column.category)
        .filter(category => this.isAllCategorySFieldsSelected(category));
    }

    return categories;
  }

  set columnCategories(categories: Category[]) {
    categories.forEach(category => {
      if (!this.selected.columnCategories.includes(category)) {
        const fields = this.columns
          .filter(column => column.category === category)
          .map(column => column.fields.map(field => field.id));

        this.selected.fields = Array.from(
          new Set([...this.selected.fields, ...fields])
        );
      }
    });

    this.selected.columnCategories = categories;
  }

  get protocols() {
    let protocols: String[] = [];
    const groups = this.groups.filter(group =>
      this.selected.groups.includes(group.id)
    );

    groups.forEach(group => (protocols = [...protocols, ...group.protocols]));

    return Array.from(new Set(protocols));
  }

  get showColumns() {
    return this.category && this.category.columns.length > 0;
  }

  get showProtocols() {
    return this.protocols.length;
  }

  get showGroups() {
    return this.groups && this.groups.length;
  }

  get showSearch() {
    return (
      this.selected &&
      (this.selected.affairs &&
        this.selected.affairs.length &&
        this.selected.sessions &&
        this.selected.sessions.length &&
        this.selected.category &&
        (!this.showColumns || (this.showColumns && this.selected.columns)) &&
        (!this.showGroups || (this.showGroups && this.selected.groups)) &&
        (!this.showProtocols ||
          (this.showProtocols && this.selected.protocols)) &&
        this.selected.columns)
    );
  }

  isAllCategorySFieldsSelected(category: String): boolean {
    let response = false;

    if (this.category) {
      const column = this.category!.columns.find(
        column => column.category === category
      );

      if (column) {
        response = !column.fields.some(
          field => !this.selected.fields.includes(field.id)
        );
      }
    }

    return response;
  }

  toggleFieldsByCategory(category: String) {
    if (this.category) {
      const column = this.category!.columns.find(
        column => column.category === category
      );

      if (column) {
        const fields = column.fields.map(field => field.id);

        if (!this.isAllCategorySFieldsSelected(category)) {
          this.selected.fields = Array.from(
            new Set([...this.selected.fields, ...fields])
          );
        } else {
          this.selected.fields = this.selected.fields.filter(
            field => !fields.includes(field)
          );
        }
      }
    }
  }

  reset() {
    this.selected = new Selected();
  }

  toggleAffairs() {
    this.$nextTick(() => {
      if (this.selected.affairs.length > 0) {
        this.selected.affairs = [];
      } else {
        this.selected.affairs = this.filter.affairs.map(affair => affair.id).slice();
      }
    });
  }

  toggleSessions() {
    this.$nextTick(() => {
      if (this.selected.sessions.length > 0) {
        this.selected.sessions = [];
      } else {
        this.selected.sessions = this.filter.sessions.map(session => session.id).slice();
      }
    });
  }

  toggleGroups() {
    this.$nextTick(() => {
      if (this.selected.groups.length > 0) {
        this.selected.groups = [];
      } else {
        this.selected.groups = this.filter.groups.map(group => group.id).slice();
      }
    });
  }

  toggleProtocols() {
    this.$nextTick(() => {
      if (this.selected.protocols.length > 0) {
        this.selected.protocols = [];
      } else {
        this.selected.protocols = this.filter.protocols.map(protocol => protocol.id).slice();
      }
    });
  }

  async fetchFilter() {
    this.overlay.text = 'Chargement des filtres...';
    this.overlay.show = true;

    let response: ApiResponseOld|null = null;

    try {
      response = await fetchFilters();
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
      this.overlay.show = false;
    }

    if (null !== response && response.error === 'success') {
      const filter = response.data as Filter;

      this.filter.affairs = filter.affairs;
      this.filter.sessions = filter.sessions;
      this.filter.categories = filter.categories;
    }

    this.overlay.show = false;
  }

  async fetchResult() {
    this.dialog = false;
    this.overlay.text = 'Recherche en cours...';
    this.overlay.show = true;

    let response: ApiResponseOld|null = null;

    try {
      response = await fetchResult(this.selected);
    } catch (e) {
      this.alert = new Alert(e.toString(), AlertTypes.Error, true);
    }

    if (null !== response && response.error === 'success') {
      const result = response.data;


      // (result as []).forEach((item: any) => console.log(item));
      // let items: {}[] = (result as []).map((item: any) => item[0] ? item[0] : []);
      // let items: {}[] = result;
      let items: {}[] = [];
      let properties: {}[] = [];

      //@ts-ignore
      for (let [group, data] of Object.entries(result)) {
        //@ts-ignore
        Array.from(data).forEach((item, index, array) => {
          //@ts-ignore
          items.push({...item, __group: group});
          if (index === array.length - 1) {
            //@ts-ignore
            let keys = [...Object.keys(item), '__group'];
            keys.forEach(key => {
              if (properties.indexOf(key) === -1) {
                properties.push({
                  text: key,
                    align: 'left',
                  sortable: true,
                  value: key,
                });
              }
            });
          }
        });
      }

      this.result = {items, properties};
    }

    this.overlay.show = false;
  }

  mounted() {
    this.fetchFilter();
  }
}
